import * as React from 'react'
// components
import { LoaderWithOverlay } from 'components/UI'
// context
import { StrategyActionsAPIContext } from 'containers/StrategyActions/layers/API'
import { StrategyActionsBLContext } from 'containers/StrategyActions/layers/BL'
// view components
import InfoPanel from './components/InfoPanel'
import FilterPanel from './components/FiltersPanel'
// container
import TasksListContainer from 'containers/StrategyActions/components/TasksList'
// hooks
import { useReviewsToApproveTasks } from 'containers/StrategyActions/layers/API/useReviewsToApproveTasks'
// utils
import groupBy from 'lodash/groupBy'

const StrategyActions: React.FC = () => {
  const { items, isLoading, plans } = React.useContext(StrategyActionsAPIContext)
  const { isGroupedByPlan } = React.useContext(StrategyActionsBLContext)

  const approvalTasks = useReviewsToApproveTasks()

  // grouped by plan, approvals go to their own plans; approvals of plans outside the list aren't shown
  const approvalTasksByPlan = React.useMemo(() => groupBy(approvalTasks, 'planId'), [approvalTasks])

  return React.useMemo(
    () => (
      isLoading ? <LoaderWithOverlay isLoading={isLoading} height='100%' /> :
        <div>
          <InfoPanel />
          <FilterPanel />
          {isGroupedByPlan ? (
            plans.map(plan => (
              <TasksListContainer key={plan.id} plan={plan} extraTasks={approvalTasksByPlan[plan.id]} />
            ))
          ) : (
            <TasksListContainer plan={items} extraTasks={approvalTasks} />
          )}
        </div>
    ),
    [isGroupedByPlan, isLoading, plans, items, approvalTasks, approvalTasksByPlan]
  )
}

export default StrategyActions
